import React, { useEffect, useState } from 'react';
import api from 'api/api';
import Loader from 'ui/Loader/Loader';
import NoBeneficiary from 'components/modules/Beneficiaries/NoBeneficiary/NoBeneficiary';
import BeneficiaryTable from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryTable';
import BeneficiaryRow from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryRow/BeneficiaryRow';
import BeneficiaryCol from 'components/modules/Beneficiaries/BeneficiaryTable/BeneficiaryCol/BeneficiaryCol';
import { IInstantBank, IBank } from 'components/modules/Beneficiaries/Beneficiaries.model';
import { IApiBeneficiaryOtherBankResponse, IBeneficiaryOtherBank } from './BenOtherBank.model';
import EditBenOtherBank from './EditBenOtherBank';

enum States {
  browsing = 'browsing',
  editing = 'editing',
}

interface IBenOtherBank {
  instantBanks: IInstantBank[];
  nonInstantBanks: IBank[];
}

const BenOtherBank = ({ instantBanks, nonInstantBanks }: IBenOtherBank) => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState<IBeneficiaryOtherBank[]>([]);
  const [editData, setEditData] = useState<IBeneficiaryOtherBank | null>(null);

  const [state, setState] = useState<States>(States.browsing);

  const fetchBeneficiaries = () => {
    const requestBody = {
      transferType: 'INSTANT_INTERBANK,NON_INSTANT_INTERBANK',
    };
    api
      .post('beneficiary/transfer/otherBank', requestBody)
      .then((response: IApiBeneficiaryOtherBankResponse) => {
        setData(response.beneficiaries);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    setLoadingData(true);
    Promise.all([fetchBeneficiaries()]).finally(() => {
      setLoadingData(false);
    });
  }, []);

  const openEditForm = (e: React.MouseEvent<HTMLDivElement>) => {
    setState(States.editing);
    const object = data.find(({ id }) => id === Number(e.currentTarget.id));
    if (object) {
      setEditData(object);
    }
  };

  const closeEditForm = () => {
    setState(States.browsing);
    setData([]);
    setLoadingData(true);
    Promise.all([fetchBeneficiaries()]).finally(() => {
      setLoadingData(false);
    });
  };

  if (state === States.editing && editData) {
    return (
      <EditBenOtherBank
        data={editData}
        onClose={closeEditForm}
        instantBanks={instantBanks}
        nonInstantBanks={nonInstantBanks}
      />
    );
  }
  const renderTable = () => (
    <BeneficiaryTable>
      {data && data.map((beneficiary) => (
        <BeneficiaryRow onClick={openEditForm} id={String(beneficiary.id)} key={beneficiary.id}>
          <BeneficiaryCol label="Full Name" value={beneficiary.name} width="30%" minWidth="200px" />
          <BeneficiaryCol label="Account Number" value={beneficiary.accountNumber} width="20%" minWidth="200px" />
          <BeneficiaryCol label="Transfer Type" value={beneficiary.transferType} width="20%" minWidth="200px" />
          <BeneficiaryCol label="Bank" value={beneficiary.bankName} width="20%" minWidth="200px" />
          <BeneficiaryCol label="Bank Branch" value={beneficiary.bankBranch} width="100%" minWidth="200px" />
        </BeneficiaryRow>
      ))}
    </BeneficiaryTable>
  );

  return (
    <>
      {loadingData && <Loader fullHeight />}
      {!loadingData && (data && data.length === 0) && <NoBeneficiary />}
      {!loadingData && (data && data.length > 0) && renderTable()}
    </>
  );
};

export default BenOtherBank;
